module.exports = __webpack_public_path__ + "img/changzhou.4e4b5da8.jpg";